<div class="annual-outcome-wrapper">
  <div class="details dis-flex flex-sb">
    <div class="tags m-b-15">
      <div class="dis-flex">
        <p-chip class="theme">
          <span
            class="theme-color theme-green"
            [style.background-color]="outcomeData?.theme?.color"
          ></span>
          <span class="title b3 text-80 lh-2-0">
            {{ outcomeData?.theme?.value }}
          </span>
        </p-chip>
        <p-divider class="vertical-divider" layout="vertical" />
        <p-chip
          class="b3 radius-8 status-chip"
          [ngClass]="{
            'not-started': outcomeData.status === 1,
            ongoing: outcomeData.status === 2,
            completed: outcomeData.status === 3,
            delayed: outcomeData.status === 4,
            terminated: outcomeData.status === 5
          }"
          [label]="getLabel(outcomeData?.status)"
        />
      </div>
    </div>
    <div class="action-items annual-outcome-items p-t-4" *ngIf="sidebarService.is_affiliate == 'no'">
      <ng-icon
        class="m-r-15 pointer-cursor icon-hover-primary"
        [name]="!isShowOutcomes ? 'hugeView' : 'hugeViewOff'"
        *ngIf="showActionMenu()"
        (click)="clickViewOutcome(outcomeData?.outcome_id)"
        [ngbTooltip]="
          !isShowOutcomes
            ? 'View STO and Milestones'
            : 'Hide STO and Milestones'
        "
        tooltipPosition="right"
      />
      <ng-icon
        class="m-r-15 m-l-15 pointer-cursor icon-hover-primary"
        name="hugeEdit02"
        ngbTooltip="Edit Outcome"
        (click)="openModal(index)"
        *ngIf="outcomeData.status != 5"
      ></ng-icon>
      <button
        class="icon-only-btn pointer-cursor"
        ngbTooltip="Action Items"
        [ngbPopover]="actionItemsMenu"
        *ngIf="outcomeData.status != 5"
      >
        <ng-icon class="icon-hover-primary" name="hugeMoreVerticalCircle01" />
      </button>
      <ng-template #actionItemsMenu>
        <div class="action-item-list">
          <a
            type="button"
            class="dis-flex p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4"
            (click)="openWizard()"
          >
            <ng-icon class="text-80 lh-1-0" name="hugeAdd01" size="18" />
            <span class="b2 text-80 m-l-10">Create Backlogs</span>
          </a>
          <a
            type="button"
            (click)="openTerminateModal()"
            class="dis-flex danger-action-item p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4"
          >
            <ng-icon class="text-80 lh-1-0" name="hugeDelete02" size="18" />
            <span class="b2 text-80 m-l-10">Mark as Terminated</span>
          </a>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="content-title">
    <h3 class="font-medium">
      {{ outcomeData.value }}
    </h3>
  </div>
</div>
<app-backlog
  [userData]="userData"
  *ngFor="let backlog of outcomeData?.backlogs"
  [backlogData]="backlog"
  [outcomeData]="outcomeData"
></app-backlog>
<div
  class="quarterly-outcome-card"
  *ngIf="detailOutcomeData?.quarterly && isShowOutcomes"
>
  <app-quarterly-outcome
    [isAnnual]="true"
    [quarterlyOutcomesLists]="detailOutcomeData?.quarterly"
    (notifyParent)="handleChildEvent($event)"
  ></app-quarterly-outcome>
</div>

<p-dialog
  header="Edit Outcome"
  class="edit-outcome-modal"
  [(visible)]="isModalOpen"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '400px' }"
>
  <div *ngIf="currentOutcome" class="m-t-15">
    <label for="outcomeField" class="b2 text-90"
      >Fill in the placeholders:</label
    >
    <div
      *ngFor="let input of [].constructor(countInputs); let i = index"
      class="mb-2"
    >
      <input
        id="outcomeField-{{ i }}"
        type="text"
        class="b3 text-90 w-full"
        placeholder="Enter value for field {{ i + 1 }}"
        [(ngModel)]="inputValues[i]"
      />
    </div>
  </div>

  <div class="dis-flex m-t-60 flex-r">
    <button class="btn outline wd-100px m-r-10" (click)="closeModal()">
      Cancel
    </button>
    <button class="btn primary wd-100px" (click)="saveOutcome()">Save</button>
  </div>
</p-dialog>

<p-dialog
  header="Terminate ?"
  class="action-item-modal b1 font-medium"
  [modal]="true"
  [(visible)]="isOpenTerminateModal"
  [style]="{ width: '30rem' }"
>
  <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
    <div class="dis-flex flex-col">
      <p class="b2 m-b-0 text-70">
        Are you sure, you want to
        <span class="font-medium text-80"> terminate the MTO</span>
        ?
      </p>
    </div>
  </div>
  <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
    <button class="btn outline wd-100px m-r-10" (click)="closeTerminateModal()">
      No
    </button>
    <button class="btn primary wd-100px" (click)="terminateTrigger()">
      Yes
    </button>
  </div>
</p-dialog>
